import { render, staticRenderFns } from "./socialBillDetail.vue?vue&type=template&id=30aa56c8&scoped=true"
import script from "./socialBillDetail.vue?vue&type=script&lang=js"
export * from "./socialBillDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./socialBillDetail.vue?vue&type=style&index=1&id=30aa56c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa56c8",
  null
  
)

export default component.exports